/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const sthlmPride: CommunityData = {
  code: "sthlmpride",
  inviteCode: "sthlmpride",
  name: "Stockholm Pride",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/sthlmpride`,
  socials: {},
  styles: {
    global: {
      werzLogoColor: "#000000",
      mobileOnly: true,
      counterColor: "#FFFFFF",
      alternativeLogo: {
        src: "https://media.werz.at/community-assets/sthlmpride/web-logo.png",
        styles: "w-[204px] mb-[-20px]",
      },
      logo: {
        src: "https://media.werz.at/community-assets/sthlmpride/web-logo.png",
        styles: "w-[316px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      contentBoxShadow: "border-[2px] rounded-[8px] border-[#FFF]",
      bgColor: "#E3B3F6",
      asideBg: "#E3B3F6",
      asideStyles: "border-r-[1px] border-r-[#FFF]",
      contentBg: "#E3B3F6",
      bgDesktop: "https://media.werz.at/community-assets/sthlmpride/web-bg.jpg",
      bgMobile: "https://media.werz.at/community-assets/sthlmpride/web-bg.jpg",
      mainFont: "font-['CitrusGothic-Regular']",
      nonMemberBg: "https://media.werz.at/community-assets/sthlmpride/web-bg.jpg",
      primaryButton:
        "flex mt-2 !text-[#0A0A0A] rounded-[8px] font-['CitrusGothic-Regular'] font-medium justify-center items-center !text-[18px] leading-[24px] !h-[48px] bg-[#0A0A0A] !px-[32px] sm:!min-w-[154px] min-w-[160px] text-nowrap cursor-pointer",
    },
    navigation: {
      sideBarSeparator: "border-r-[1px] border-[#000000]",
      iconsColor: "#0A0A0A",
      separator: "border-t-[#FFF] border-t",
      item: "text-[18px] h-[44px] text-[#FFF] flex justify-center items-center sm:!pt-2 !pt-6 sm:!pl-0",
      itemSelected: "text-[#000000]",
    },
    communityLanding: {
      container: "!pt-0",
      titles: "text-[40px] leading-[48px] font-['CitrusGothic-Regular'] text-[#FFFFFF] uppercase",
      announcements: {
        lg: {
          subtitle:
            "!text-[12px] font-['SpaceMono-Regular'] !bg-transparent !-mb-1 !-ml-0.5 !text-[#FFFFF]",
          title:
            "font-['CitrusGothic-Regular'] font-medium !text-[#FFFFFF] !text-[32px] -mb-2 mt-[-4px] w-fit flex items-cente pt-1",
        },
        sm: {
          subtitle:
            "!text-[12px] font-['SpaceMono-Regular'] !bg-transparent !-mb-1 !-ml-0.5 !text-[#FFFFF]",
          title:
            "font-['CitrusGothic-Regular'] !text-[#FFFFFF] !text-[18px] mt-[-4px] w-fit flex items-cente pt-1",
        },
      },
      event: {
        media: "!w-[160px] !h-[160px]",
        container: "!pt-6 border-b border-t border-[#FFF] !mt-0",
        title:
          "font-['CitrusGothic-Regular'] !text-[#FFFFFF] !text-[18px]  text-[#FFFFFF] one-line-truncate",
        subtitle: "!text-[12px] font-['SpaceMono-Regular'] text-[#FFFFFF] leading-[16px] uppercase",
      },
      shop: {
        container: "!mt-0 !pt-8",
        sectionTitle: "hidden",
        title: "text-[40px] text-[#FFFFFF] font-['CitrusGothic-Regular']",
        text: "text-[12px] font-['SpaceMono-Regular'] text-[#FFFFFF]",
        customShopImage: "https://media.werz.at/community-assets/nattoga/shop-web.png",
      },
      emptyOrLoadingState: "text-[16px] !text-[#FFFFFF]",
    },
  },
}

export default sthlmPride
